import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LangProvider } from "@/lib/i18n";
import AppShell from "@/components/AppShell";
import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import DashboardPage from "@/pages/DashboardPage";
import VehicleListPage from "@/pages/VehicleListPage";
import VehicleDetailPage from "@/pages/VehicleDetailPage";
import CaptureWizardPage from "@/pages/CaptureWizardPage";
import FotoboothPage from "@/pages/FotoboothPage";
import PublishingPage from "@/pages/PublishingPage";
import ContentPage from "@/pages/ContentPage";
import IntegrationsPage from "@/pages/IntegrationsPage";
import SettingsPage from "@/pages/SettingsPage";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-sm text-muted-foreground animate-pulse">Wird geladen...</div>
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return <AppShell>{children}</AppShell>;
};

function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Oeffentlich */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/registrieren" element={<RegisterPage />} />

            {/* App (hinter Login) */}
            <Route path="/app" element={<Protected><DashboardPage /></Protected>} />
            <Route path="/app/fahrzeuge" element={<Protected><VehicleListPage /></Protected>} />
            <Route path="/app/fahrzeuge/:id" element={<Protected><VehicleDetailPage /></Protected>} />
            <Route path="/app/aufnehmen" element={<Protected><CaptureWizardPage /></Protected>} />
            <Route path="/app/fotobooth" element={<Protected><FotoboothPage /></Protected>} />
            <Route path="/app/veroeffentlichen" element={<Protected><PublishingPage /></Protected>} />
            <Route path="/app/content" element={<Protected><ContentPage /></Protected>} />
            <Route path="/app/integrationen" element={<Protected><IntegrationsPage /></Protected>} />
            <Route path="/app/einstellungen" element={<Protected><SettingsPage /></Protected>} />

            {/* Alte Routen weiterleiten */}
            <Route path="/fahrzeuge" element={<Navigate to="/app/fahrzeuge" replace />} />
            <Route path="/fahrzeuge/:id" element={<LegacyVehicleRedirect />} />
            <Route path="/aufnehmen" element={<Navigate to="/app/aufnehmen" replace />} />
            <Route path="/veroeffentlichen" element={<Navigate to="/app/veroeffentlichen" replace />} />
            <Route path="/content" element={<Navigate to="/app/content" replace />} />
            <Route path="/integrationen" element={<Navigate to="/app/integrationen" replace />} />
            <Route path="/einstellungen" element={<Navigate to="/app/einstellungen" replace />} />
            <Route path="/pipeline" element={<Navigate to="/app/fahrzeuge" replace />} />
            <Route path="/aufgaben" element={<Navigate to="/app/fahrzeuge" replace />} />
            <Route path="/team" element={<Navigate to="/app/einstellungen" replace />} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </AuthProvider>
    </LangProvider>
  );
}

const LegacyVehicleRedirect = () => {
  const id = window.location.pathname.split("/").pop();
  return <Navigate to={`/app/fahrzeuge/${id}`} replace />;
};

export default App;
